<app-loading [busy]="loading"></app-loading>

<ng-container *ngIf="!loading">
  <div class="card mb-4">
    <div class="card-header">Add Reservation</div>
    <div class="card-body p-3">
      <div class="row">
        <div class="col-md-2">
          <select
            mdbInput
            id="reservationYear"
            name="reservationYear"
            [(ngModel)]="newReservationYear"
            [ngModelOptions]="{ standalone: true }"
            class="form-control browser-default"
          >
            <option [ngValue]="null">Select Year</option>
            <option *ngFor="let year of availableYears" [ngValue]="year">{{ year }}</option>
          </select>
        </div>
        <div class="col-md-2">
          <input
            mdbInput
            type="number"
            id="reservationAmount"
            name="reservationAmount"
            [(ngModel)]="newReservationAmount"
            [ngModelOptions]="{ standalone: true }"
            class="form-control"
            placeholder="Enter amount"
          />
        </div>
        <div class="col-md-5">
          <input
            mdbInput
            type="text"
            id="reservationComment"
            name="reservationComment"
            [(ngModel)]="newReservationComment"
            [ngModelOptions]="{ standalone: true }"
            class="form-control"
            placeholder="Enter comment"
          />
        </div>
        <div class="col-md-2 align-items-end">
          <button
            type="button"
            mdbBtn
            color="trakly-action"
            class="relative waves-light w-100"
            (click)="addReservation()"
            [disabled]="!isFormValid"
          >
            Add
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="card mb-4" *ngFor="let year of availableYears">
    <div *ngIf="year == this.currentYear" class="card-header d-flex justify-content-between align-items-center">
      <span>
        {{ year }}&nbsp; Total: <strong>R</strong>&nbsp;<strong>{{ this.currentFiaReservedAmount | number: "1.0-0" }}</strong>
        &nbsp;
        <strong style="color: red" *ngIf="hasDifference()"
          >(Fix this difference from Profile: R
          {{ this.currentFiaReservedAmount - calculateTotalReservedForYear(year) | number: "1.0-0" }})</strong
        >
      </span>
      <span *ngIf="loadingAvailable" class="spinner-grow"></span>
      <span *ngIf="!loadingAvailable">FIA Available: R {{ fiaAvailable | number: "1.0-0" }}</span>
      <span *ngIf="fiaAvailableError" style="color: red">{{ fiaAvailableError }}</span>
    </div>
    <div *ngIf="year !== this.currentYear" class="card-header">
      {{ year }} Total: <strong>R</strong>&nbsp;<strong>{{ calculateTotalReservedForYear(year) | number: "1.0-0" }}</strong>
    </div>
    <div class="card-body p-2">
      <table mdbTable small="true" class="table-sm mb-0">
        <thead *ngIf="getReservationsForYear(year).length > 0">
          <tr>
            <th class="py-2" style="width: 120px; text-align: center">Amount</th>
            <th class="py-2" style="width: auto">Comments</th>
            <th class="py-2" style="width: 200px; text-align: center">By</th>
            <th class="py-2" style="width: 100px; text-align: center">Date</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="getReservationsForYear(year).length === 0">
            <td colspan="4" style="border-top: none">No Reservations</td>
          </tr>
          <tr *ngFor="let reservation of getReservationsForYear(year)">
            <td class="py-1" style="text-align: center">{{ reservation.amount | number }}</td>
            <td class="py-1">{{ reservation.comment }}</td>
            <td class="py-1" style="text-align: center">{{ reservation.createdByUserName }}</td>
            <td class="py-1" style="text-align: center">{{ reservation.created | date: "dd MMM" }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-container>

<error-component [error]="errorResponse" [(showModal)]="showError"></error-component>
